/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AdminRouteImport } from './routes/_admin'
import { Route as LoginRouteImport } from './routes/login'
import { Route as AdminIndexRouteImport } from './routes/_admin/index'
import { Route as AdminAtividadeRouteImport } from './routes/_admin/atividade'
import { Route as AdminPerfisRouteImport } from './routes/_admin/perfis'
import { Route as AdminUsuariosRouteImport } from './routes/_admin/usuarios'
import { Route as AdminVisitasRouteImport } from './routes/_admin/visitas'
import { Route as AuthCallbackRouteImport } from './routes/auth.callback'
import { Route as AdminCursosIndexRouteImport } from './routes/_admin/cursos/index'
import { Route as AdminCursosCourseIdRouteImport } from './routes/_admin/cursos/$courseId'
import { Route as AdminEventosIndexRouteImport } from './routes/_admin/eventos/index'
import { Route as AdminEventosEventIdRouteImport } from './routes/_admin/eventos/$eventId'
import { Route as AdminEventosNovoRouteImport } from './routes/_admin/eventos/novo'
import { Route as AdminPessoasUserIdRouteImport } from './routes/_admin/pessoas.$userId'
import { Route as AdminProdutosIndexRouteImport } from './routes/_admin/produtos/index'
import { Route as AdminProdutosProductIdRouteImport } from './routes/_admin/produtos/$productId'
import { Route as AdminProdutosNovoRouteImport } from './routes/_admin/produtos/novo'
import { Route as AdminCenturiaFluxosIndexRouteImport } from './routes/_admin/centuria/fluxos/index'
import { Route as AdminCenturiaFluxosFlowIdRouteImport } from './routes/_admin/centuria/fluxos/$flowId'
import { Route as AdminCursosCourseIdAulasLessonIdRouteImport } from './routes/_admin/cursos/$courseId_.aulas.$lessonId'

const AdminRoute = AdminRouteImport.update({
  id: '/_admin',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminIndexRoute = AdminIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdminRoute,
} as any)
const AdminAtividadeRoute = AdminAtividadeRouteImport.update({
  id: '/atividade',
  path: '/atividade',
  getParentRoute: () => AdminRoute,
} as any)
const AdminPerfisRoute = AdminPerfisRouteImport.update({
  id: '/perfis',
  path: '/perfis',
  getParentRoute: () => AdminRoute,
} as any)
const AdminUsuariosRoute = AdminUsuariosRouteImport.update({
  id: '/usuarios',
  path: '/usuarios',
  getParentRoute: () => AdminRoute,
} as any)
const AdminVisitasRoute = AdminVisitasRouteImport.update({
  id: '/visitas',
  path: '/visitas',
  getParentRoute: () => AdminRoute,
} as any)
const AuthCallbackRoute = AuthCallbackRouteImport.update({
  id: '/auth/callback',
  path: '/auth/callback',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminCursosIndexRoute = AdminCursosIndexRouteImport.update({
  id: '/cursos/',
  path: '/cursos/',
  getParentRoute: () => AdminRoute,
} as any)
const AdminCursosCourseIdRoute = AdminCursosCourseIdRouteImport.update({
  id: '/cursos/$courseId',
  path: '/cursos/$courseId',
  getParentRoute: () => AdminRoute,
} as any)
const AdminEventosIndexRoute = AdminEventosIndexRouteImport.update({
  id: '/eventos/',
  path: '/eventos/',
  getParentRoute: () => AdminRoute,
} as any)
const AdminEventosEventIdRoute = AdminEventosEventIdRouteImport.update({
  id: '/eventos/$eventId',
  path: '/eventos/$eventId',
  getParentRoute: () => AdminRoute,
} as any)
const AdminEventosNovoRoute = AdminEventosNovoRouteImport.update({
  id: '/eventos/novo',
  path: '/eventos/novo',
  getParentRoute: () => AdminRoute,
} as any)
const AdminPessoasUserIdRoute = AdminPessoasUserIdRouteImport.update({
  id: '/pessoas/$userId',
  path: '/pessoas/$userId',
  getParentRoute: () => AdminRoute,
} as any)
const AdminProdutosIndexRoute = AdminProdutosIndexRouteImport.update({
  id: '/produtos/',
  path: '/produtos/',
  getParentRoute: () => AdminRoute,
} as any)
const AdminProdutosProductIdRoute = AdminProdutosProductIdRouteImport.update({
  id: '/produtos/$productId',
  path: '/produtos/$productId',
  getParentRoute: () => AdminRoute,
} as any)
const AdminProdutosNovoRoute = AdminProdutosNovoRouteImport.update({
  id: '/produtos/novo',
  path: '/produtos/novo',
  getParentRoute: () => AdminRoute,
} as any)
const AdminCenturiaFluxosIndexRoute =
  AdminCenturiaFluxosIndexRouteImport.update({
    id: '/centuria/fluxos/',
    path: '/centuria/fluxos/',
    getParentRoute: () => AdminRoute,
  } as any)
const AdminCenturiaFluxosFlowIdRoute =
  AdminCenturiaFluxosFlowIdRouteImport.update({
    id: '/centuria/fluxos/$flowId',
    path: '/centuria/fluxos/$flowId',
    getParentRoute: () => AdminRoute,
  } as any)
const AdminCursosCourseIdAulasLessonIdRoute =
  AdminCursosCourseIdAulasLessonIdRouteImport.update({
    id: '/cursos/$courseId_/aulas/$lessonId',
    path: '/cursos/$courseId/aulas/$lessonId',
    getParentRoute: () => AdminRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof AdminIndexRoute
  '/login': typeof LoginRoute
  '/atividade': typeof AdminAtividadeRoute
  '/perfis': typeof AdminPerfisRoute
  '/usuarios': typeof AdminUsuariosRoute
  '/visitas': typeof AdminVisitasRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/cursos/$courseId': typeof AdminCursosCourseIdRoute
  '/eventos/$eventId': typeof AdminEventosEventIdRoute
  '/eventos/novo': typeof AdminEventosNovoRoute
  '/pessoas/$userId': typeof AdminPessoasUserIdRoute
  '/produtos/$productId': typeof AdminProdutosProductIdRoute
  '/produtos/novo': typeof AdminProdutosNovoRoute
  '/cursos/': typeof AdminCursosIndexRoute
  '/eventos/': typeof AdminEventosIndexRoute
  '/produtos/': typeof AdminProdutosIndexRoute
  '/centuria/fluxos/$flowId': typeof AdminCenturiaFluxosFlowIdRoute
  '/centuria/fluxos/': typeof AdminCenturiaFluxosIndexRoute
  '/cursos/$courseId/aulas/$lessonId': typeof AdminCursosCourseIdAulasLessonIdRoute
}
export interface FileRoutesByTo {
  '/login': typeof LoginRoute
  '/atividade': typeof AdminAtividadeRoute
  '/perfis': typeof AdminPerfisRoute
  '/usuarios': typeof AdminUsuariosRoute
  '/visitas': typeof AdminVisitasRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/': typeof AdminIndexRoute
  '/cursos/$courseId': typeof AdminCursosCourseIdRoute
  '/eventos/$eventId': typeof AdminEventosEventIdRoute
  '/eventos/novo': typeof AdminEventosNovoRoute
  '/pessoas/$userId': typeof AdminPessoasUserIdRoute
  '/produtos/$productId': typeof AdminProdutosProductIdRoute
  '/produtos/novo': typeof AdminProdutosNovoRoute
  '/cursos': typeof AdminCursosIndexRoute
  '/eventos': typeof AdminEventosIndexRoute
  '/produtos': typeof AdminProdutosIndexRoute
  '/centuria/fluxos/$flowId': typeof AdminCenturiaFluxosFlowIdRoute
  '/centuria/fluxos': typeof AdminCenturiaFluxosIndexRoute
  '/cursos/$courseId/aulas/$lessonId': typeof AdminCursosCourseIdAulasLessonIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_admin': typeof AdminRouteWithChildren
  '/login': typeof LoginRoute
  '/_admin/atividade': typeof AdminAtividadeRoute
  '/_admin/perfis': typeof AdminPerfisRoute
  '/_admin/usuarios': typeof AdminUsuariosRoute
  '/_admin/visitas': typeof AdminVisitasRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/_admin/': typeof AdminIndexRoute
  '/_admin/cursos/$courseId': typeof AdminCursosCourseIdRoute
  '/_admin/eventos/$eventId': typeof AdminEventosEventIdRoute
  '/_admin/eventos/novo': typeof AdminEventosNovoRoute
  '/_admin/pessoas/$userId': typeof AdminPessoasUserIdRoute
  '/_admin/produtos/$productId': typeof AdminProdutosProductIdRoute
  '/_admin/produtos/novo': typeof AdminProdutosNovoRoute
  '/_admin/cursos/': typeof AdminCursosIndexRoute
  '/_admin/eventos/': typeof AdminEventosIndexRoute
  '/_admin/produtos/': typeof AdminProdutosIndexRoute
  '/_admin/centuria/fluxos/$flowId': typeof AdminCenturiaFluxosFlowIdRoute
  '/_admin/centuria/fluxos/': typeof AdminCenturiaFluxosIndexRoute
  '/_admin/cursos/$courseId_/aulas/$lessonId': typeof AdminCursosCourseIdAulasLessonIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/atividade'
    | '/perfis'
    | '/usuarios'
    | '/visitas'
    | '/auth/callback'
    | '/cursos/$courseId'
    | '/eventos/$eventId'
    | '/eventos/novo'
    | '/pessoas/$userId'
    | '/produtos/$productId'
    | '/produtos/novo'
    | '/cursos/'
    | '/eventos/'
    | '/produtos/'
    | '/centuria/fluxos/$flowId'
    | '/centuria/fluxos/'
    | '/cursos/$courseId/aulas/$lessonId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/login'
    | '/atividade'
    | '/perfis'
    | '/usuarios'
    | '/visitas'
    | '/auth/callback'
    | '/'
    | '/cursos/$courseId'
    | '/eventos/$eventId'
    | '/eventos/novo'
    | '/pessoas/$userId'
    | '/produtos/$productId'
    | '/produtos/novo'
    | '/cursos'
    | '/eventos'
    | '/produtos'
    | '/centuria/fluxos/$flowId'
    | '/centuria/fluxos'
    | '/cursos/$courseId/aulas/$lessonId'
  id:
    | '__root__'
    | '/_admin'
    | '/login'
    | '/_admin/atividade'
    | '/_admin/perfis'
    | '/_admin/usuarios'
    | '/_admin/visitas'
    | '/auth/callback'
    | '/_admin/'
    | '/_admin/cursos/$courseId'
    | '/_admin/eventos/$eventId'
    | '/_admin/eventos/novo'
    | '/_admin/pessoas/$userId'
    | '/_admin/produtos/$productId'
    | '/_admin/produtos/novo'
    | '/_admin/cursos/'
    | '/_admin/eventos/'
    | '/_admin/produtos/'
    | '/_admin/centuria/fluxos/$flowId'
    | '/_admin/centuria/fluxos/'
    | '/_admin/cursos/$courseId_/aulas/$lessonId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AdminRoute: typeof AdminRouteWithChildren
  LoginRoute: typeof LoginRoute
  AuthCallbackRoute: typeof AuthCallbackRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_admin': {
      id: '/_admin'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AdminRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_admin/': {
      id: '/_admin/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AdminIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/atividade': {
      id: '/_admin/atividade'
      path: '/atividade'
      fullPath: '/atividade'
      preLoaderRoute: typeof AdminAtividadeRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/perfis': {
      id: '/_admin/perfis'
      path: '/perfis'
      fullPath: '/perfis'
      preLoaderRoute: typeof AdminPerfisRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/usuarios': {
      id: '/_admin/usuarios'
      path: '/usuarios'
      fullPath: '/usuarios'
      preLoaderRoute: typeof AdminUsuariosRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/visitas': {
      id: '/_admin/visitas'
      path: '/visitas'
      fullPath: '/visitas'
      preLoaderRoute: typeof AdminVisitasRouteImport
      parentRoute: typeof AdminRoute
    }
    '/auth/callback': {
      id: '/auth/callback'
      path: '/auth/callback'
      fullPath: '/auth/callback'
      preLoaderRoute: typeof AuthCallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_admin/cursos/': {
      id: '/_admin/cursos/'
      path: '/cursos'
      fullPath: '/cursos/'
      preLoaderRoute: typeof AdminCursosIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/cursos/$courseId': {
      id: '/_admin/cursos/$courseId'
      path: '/cursos/$courseId'
      fullPath: '/cursos/$courseId'
      preLoaderRoute: typeof AdminCursosCourseIdRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/eventos/': {
      id: '/_admin/eventos/'
      path: '/eventos'
      fullPath: '/eventos/'
      preLoaderRoute: typeof AdminEventosIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/eventos/$eventId': {
      id: '/_admin/eventos/$eventId'
      path: '/eventos/$eventId'
      fullPath: '/eventos/$eventId'
      preLoaderRoute: typeof AdminEventosEventIdRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/eventos/novo': {
      id: '/_admin/eventos/novo'
      path: '/eventos/novo'
      fullPath: '/eventos/novo'
      preLoaderRoute: typeof AdminEventosNovoRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/pessoas/$userId': {
      id: '/_admin/pessoas/$userId'
      path: '/pessoas/$userId'
      fullPath: '/pessoas/$userId'
      preLoaderRoute: typeof AdminPessoasUserIdRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/produtos/': {
      id: '/_admin/produtos/'
      path: '/produtos'
      fullPath: '/produtos/'
      preLoaderRoute: typeof AdminProdutosIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/produtos/$productId': {
      id: '/_admin/produtos/$productId'
      path: '/produtos/$productId'
      fullPath: '/produtos/$productId'
      preLoaderRoute: typeof AdminProdutosProductIdRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/produtos/novo': {
      id: '/_admin/produtos/novo'
      path: '/produtos/novo'
      fullPath: '/produtos/novo'
      preLoaderRoute: typeof AdminProdutosNovoRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/centuria/fluxos/': {
      id: '/_admin/centuria/fluxos/'
      path: '/centuria/fluxos'
      fullPath: '/centuria/fluxos/'
      preLoaderRoute: typeof AdminCenturiaFluxosIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/centuria/fluxos/$flowId': {
      id: '/_admin/centuria/fluxos/$flowId'
      path: '/centuria/fluxos/$flowId'
      fullPath: '/centuria/fluxos/$flowId'
      preLoaderRoute: typeof AdminCenturiaFluxosFlowIdRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_admin/cursos/$courseId_/aulas/$lessonId': {
      id: '/_admin/cursos/$courseId_/aulas/$lessonId'
      path: '/cursos/$courseId/aulas/$lessonId'
      fullPath: '/cursos/$courseId/aulas/$lessonId'
      preLoaderRoute: typeof AdminCursosCourseIdAulasLessonIdRouteImport
      parentRoute: typeof AdminRoute
    }
  }
}

interface AdminRouteChildren {
  AdminAtividadeRoute: typeof AdminAtividadeRoute
  AdminPerfisRoute: typeof AdminPerfisRoute
  AdminUsuariosRoute: typeof AdminUsuariosRoute
  AdminVisitasRoute: typeof AdminVisitasRoute
  AdminIndexRoute: typeof AdminIndexRoute
  AdminCursosCourseIdRoute: typeof AdminCursosCourseIdRoute
  AdminEventosEventIdRoute: typeof AdminEventosEventIdRoute
  AdminEventosNovoRoute: typeof AdminEventosNovoRoute
  AdminPessoasUserIdRoute: typeof AdminPessoasUserIdRoute
  AdminProdutosProductIdRoute: typeof AdminProdutosProductIdRoute
  AdminProdutosNovoRoute: typeof AdminProdutosNovoRoute
  AdminCursosIndexRoute: typeof AdminCursosIndexRoute
  AdminEventosIndexRoute: typeof AdminEventosIndexRoute
  AdminProdutosIndexRoute: typeof AdminProdutosIndexRoute
  AdminCenturiaFluxosFlowIdRoute: typeof AdminCenturiaFluxosFlowIdRoute
  AdminCenturiaFluxosIndexRoute: typeof AdminCenturiaFluxosIndexRoute
  AdminCursosCourseIdAulasLessonIdRoute: typeof AdminCursosCourseIdAulasLessonIdRoute
}

const AdminRouteChildren: AdminRouteChildren = {
  AdminAtividadeRoute: AdminAtividadeRoute,
  AdminPerfisRoute: AdminPerfisRoute,
  AdminUsuariosRoute: AdminUsuariosRoute,
  AdminVisitasRoute: AdminVisitasRoute,
  AdminIndexRoute: AdminIndexRoute,
  AdminCursosCourseIdRoute: AdminCursosCourseIdRoute,
  AdminEventosEventIdRoute: AdminEventosEventIdRoute,
  AdminEventosNovoRoute: AdminEventosNovoRoute,
  AdminPessoasUserIdRoute: AdminPessoasUserIdRoute,
  AdminProdutosProductIdRoute: AdminProdutosProductIdRoute,
  AdminProdutosNovoRoute: AdminProdutosNovoRoute,
  AdminCursosIndexRoute: AdminCursosIndexRoute,
  AdminEventosIndexRoute: AdminEventosIndexRoute,
  AdminProdutosIndexRoute: AdminProdutosIndexRoute,
  AdminCenturiaFluxosFlowIdRoute: AdminCenturiaFluxosFlowIdRoute,
  AdminCenturiaFluxosIndexRoute: AdminCenturiaFluxosIndexRoute,
  AdminCursosCourseIdAulasLessonIdRoute: AdminCursosCourseIdAulasLessonIdRoute,
}

const AdminRouteWithChildren = AdminRoute._addFileChildren(AdminRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AdminRoute: AdminRouteWithChildren,
  LoginRoute: LoginRoute,
  AuthCallbackRoute: AuthCallbackRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
